import { generateActionCenterLink } from "grassroots/helpers"
import { ORIGINAL, FRAMELESS } from "grassroots/components/ActionCenterTableHelpers"

/**
 * copyEmbedCodeForCampaign generates iFrameCode for an Action Center / Preview Link
 * and copies it to the clipboard. This function is meant to replicate makePreviewAndCopyLinkColumns
 * in ActionCenterTableHelpers to function for the ActionColumnGrid
 */
export const copyEmbedCodeForCampaign = ({
    id,
    domain,
    frameless,
    previewLink,
    neededAttr,
    neededValue,
    extra,
    makeUrl,
}) => {
    const url = makeUrl && makeUrl({ domain, id, [neededAttr]: neededValue, frameless, extra })
    const iFrameCode = `<iframe src="${url}" style="border-radius:4px;border:1px solid #1a2d18; width:100%; min-height: 800px;"></iframe>`
    copyTextToClipboard(iFrameCode)
    // returning for testing purposes
    return iFrameCode
}

/**
 * copyTextToClipboard takes a given text and copies it to the user's clipboard.
 * @param  String text     [text to copy to clipboard]
 */
export const copyTextToClipboard = (text) => {
    // Create a dummy html element, populate with iframe code, copy to clipboard, and remove html element
    const copyTextarea = document.createElement("textarea")
    copyTextarea.innerText = text
    document.body.appendChild(copyTextarea)
    copyTextarea.select()
    document.execCommand("copy")
    copyTextarea.remove()
}

/**
 * hasValidFields checks the requiredFields of a button and checks the fields object to see if
 * each associated field is valid and return true, otherwise it will not load the button,
 * log the error, and return false.
 */
export const hasValidFields = (button, fields, props) => {
    // disable archive for persona dashboard
    if (
        fields.dataType === DjangIO.app.models.QuorumDataType.dashboard.value &&
        Object.values(Userdata.persona_dashboards).includes(fields.id) &&
        button.name === "Archive"
    ) {
        return false
    }

    if (!button.requiredFields.every((key) => fields && fields[key] !== undefined)) {
        console.error(`${button && button.name} has invalid fields listed in requiredFields`)
        return false
    }
    if (
        button.requiredResults &&
        !Object.keys(button.requiredResults).every((key) => button.requiredResults[key] === fields[key])
    ) {
        return false
    }
    if (button.checkReferenceUri && props.referenceUris.includes(fields.resource_uri)) {
        return false
    }
    return true
}

/**
 * isDisabled checks the requiredFields of an individual button to see if the disabled field is true
 * and if the current row field is true. If this function is true, the action button will appear
 * but will not be clickable or hoverable.
 *
 * @param {object} button - an action column button object, view campaigns-selectors.jsx for an example
 * @param {object} fields - returned key values associated to a specific row
 * @type {(button?: any, fields?: any, props?: any) => any}
 * @return {boolean}
 */
export const isDisabled = (button, fields) =>
    fields && button.requiredFields && button.requiredFields.includes("disabled") && fields.disabled
